import { render } from "./InputPage.vue?vue&type=template&id=b8a6feda"
import script from "./InputPage.vue?vue&type=script&lang=js"
export * from "./InputPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__